import { Item } from '@ibsys/kit';
import { FC, ReactNode } from 'react';
import { type EditablePhraseType, PHRASE_TYPES } from '@/entities/conversations';
import { cn } from '@/shared/lib';
import { RECORD_FORM_FRAME_CLASS } from './recordSide';
import { useTranscriptEditorContext } from './TranscriptEditorContext';

type Props = {
  type: EditablePhraseType;
  /** Говорящий, выбранный в форме реплики; null — не выбран */
  personId: number | null;
  /** Запись, которая правится; у новой записи её нет */
  recordId?: number;
  children: ReactNode;
};

/**
 * Рамка открытой формы записи: фон прежний, рамка — цветом стороны выбранного говорящего реплики
 * или цветом отметки события. Пока говорящий не выбран, рамка обычная.
 */
export const TranscriptRecordFormFrame: FC<Props> = ({ type, personId, recordId, children }) => {
  const { personSideById } = useTranscriptEditorContext();

  const getFrameSide = () => {
    if (type !== PHRASE_TYPES.PHRASE) return 'event';
    return personId === null ? undefined : personSideById.get(personId);
  };
  const side = getFrameSide();

  return (
    <Item variant="outline" size="sm" data-message-id={recordId} className={cn(side && RECORD_FORM_FRAME_CLASS[side])}>
      <div className="flex w-full min-w-0 flex-col gap-3">{children}</div>
    </Item>
  );
};
